"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ModalFooter = exports.ModalBody = exports.ModalTitle = exports.ModalHeader = exports.ModalContent = exports.ModalWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system"); // Handles the positioning of the Modal


var ModalWrapper = (0, _styled.default)('div')(function () {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    zIndex: 999999,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  };
}); // Sets the main Content of the Modal
// Uses props to set the width of the component

exports.ModalWrapper = ModalWrapper;
var ModalContent = (0, _styled.default)('div')(function (_ref) {
  var colors = _ref.theme.colors;
  return {
    backgroundColor: colors.primary,
    color: colors.secondary,
    width: '100%'
  };
}, function (_ref2) {
  var mediaQueries = _ref2.theme.mediaQueries;
  return (0, _styledSystem.variant)({
    prop: 'size',
    variants: {
      sm: _defineProperty({}, mediaQueries.medium, {
        width: '30%'
      }),
      md: _defineProperty({}, mediaQueries.medium, {
        width: '50%'
      }),
      lg: _defineProperty({}, mediaQueries.medium, {
        width: '80%'
      })
    }
  });
}); // Handles Styling the Header of the Modal

exports.ModalContent = ModalContent;
var ModalHeader = (0, _styled.default)('div')(function (_ref3) {
  var space = _ref3.theme.space;
  return {
    padding: space.medium
  };
}); // Handles Styling of the Title of the Modal

exports.ModalHeader = ModalHeader;
var ModalTitle = (0, _styled.default)('div')(function (_ref4) {
  var space = _ref4.theme.space;
  return {
    padding: space.medium
  };
}); // Handles Styling of the Body of the Modal

exports.ModalTitle = ModalTitle;
var ModalBody = (0, _styled.default)('div')(function (_ref5) {
  var space = _ref5.theme.space;
  return {
    padding: space.medium,
    borderTop: '1px solid #eee',
    borderBottom: '1px solid #eee'
  };
}); // Handles Styling the Footer of the Modal

exports.ModalBody = ModalBody;
var ModalFooter = (0, _styled.default)('div')(function (_ref6) {
  var space = _ref6.theme.space;
  return {
    padding: space.medium
  };
});
exports.ModalFooter = ModalFooter;